































import {Component, Ref, Vue, Watch, Prop, Emit} from 'vue-property-decorator';
import BButton from 'buefy/src/components/button/Button.vue';
import {namespace} from 'vuex-class';
import {MAFUser} from '@/store/User/types';
import {MAFViolation} from '@/store/Violations/types';
import {DateTime} from 'luxon';
// @ts-ignore
import * as firebase from 'firebase/app';
import QuerySnapshot = firebase.firestore.QuerySnapshot;
import QueryDocumentSnapshot = firebase.firestore.QueryDocumentSnapshot;


const userNamespace = namespace('userState');
const friendNamespace = namespace('friendState');
const violationsNamespace = namespace('violationState');

@Component({
  components: {
    BButton,
  },
})
/* tslint:disable:no-console */
export default class ReportUserModal extends Vue {
  @Prop() public readonly friend!: MAFUser;

  @userNamespace.State('self') public self!: MAFUser;
  @friendNamespace.State('friends') public friends!: MAFUser[];
  @violationsNamespace.Action('reportFriend') public reportFriend: any;
  public file: any = {};
  public reason: any = '';
  public details: string = '';
  public reportingOptions = [
    {
      id: 0,
      value: '',
      text: 'Select a reason',
    },
    {
      id: 1,
      value: 'Mean user',
      text: 'The user was mean.',
    },
    {
      id: 2,
      value: 'Inappropriate contact',
      text: 'The user said something inappropriate.',
    },
    {
      id: 3,
      value: 'Hurtful conversation',
      text: 'The user was saying hurtful things.',
    },
    {
      id: 4,
      value: 'Bad experience',
      text: 'I had a bad experience during our meetup.',
    },
    {
      id: 5,
      value: 'Negative audio chat experience',
      text: 'The user did something bad during our audio chat.',
    },
    {
      id: 6,
      value: 'Negative video chat experience',
      text: 'The user did something bad during our video chat.',
    },
    {
      id: 7,
      value: 'Other',
      text: 'Something else.',
    },
  ];

  public async onReportFriend() {
    const violation = new MAFViolation(undefined);
    this.self.Reference = undefined;
    this.friend.Reference = undefined;
    violation.reporter = JSON.parse(JSON.stringify(this.self));
    violation.user_reported = JSON.parse(JSON.stringify(this.friend));
    violation.date = new Date();
    violation.issue_reported = this.reason;
    violation.issue_details = this.details;
    violation.resolution = '';

    if (this.file.name) {
      const uploaded = await this.$storage.ref().child(`violations/${this.self.uid}`).put(this.file);
      const url = await this.$storage.ref().child(`violations/${this.self.uid}`).getDownloadURL();
      violation.imageUrl = url;
    } else {
      violation.imageUrl = '';
    }

    try {
      await this.reportFriend(violation);
      this.closeReportModal();
    } catch (error) {
      console.error(error);
    }
  }
  /* tslint:disable:no-empty */
  @Emit('closeReport')
  public closeReportModal() {}
  public upload() {


  }
}
